import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { ref: "selectedBonuses" }
const _hoisted_2 = {
  key: 0,
  class: "panel d-flex flex-column justify-content-center align-items-center"
}
const _hoisted_3 = {
  key: 0,
  class: "wrapper"
}
const _hoisted_4 = { class: "content" }

import TechnoFrame from "@/components/Common/TechnoFrame.vue";
import SelectedBonusesDisplay from "@/components/RegistrationPage/MobileVersion/SelectedBonusesDisplay.vue";
import PaymentInfo from "@/components/RegistrationPage/Payment/PaymentInfo.vue";

import { defineComponent } from 'vue'
import store from "@/store";
import {PassProperties} from "@/components/RegistrationPage/Card/PassProperties";

const __default__ = defineComponent({
    name: 'SelectedBonuses',

    data() {
        return {
            state: store.state,
        }
    },

    computed: {
        selectedPass(): PassProperties | null
        {
            return this.state.selectedPass
        },
    },

    watch: {
        selectedPass: {
            handler(): void
            {
                setTimeout(() => {
                    const el: HTMLDivElement = this.$refs.selectedBonuses as HTMLDivElement
                    el.scrollIntoView({
                        behavior: "smooth",
                        block: "start",
                    })
                }, 100)
            },
        },
    },
})


export default /*@__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.selectedPass)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(PaymentInfo),
          (_ctx.state.canPurchase)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createVNode(TechnoFrame, {
                  offset: 8,
                  "size-modifier": 0.4
                }),
                _createElementVNode("div", _hoisted_4, [
                  (_unref(store).state.canPurchase)
                    ? (_openBlock(), _createBlock(SelectedBonusesDisplay, { key: 0 }))
                    : _createCommentVNode("", true)
                ])
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ], 512))
}
}

})